<template>
  <div class="General">
    <div class="ContainerBtn">
      <b-button class="Btn" style="background: #3e66ae" @click="modalHeight">
        <b-icon-plus scale="1.5"></b-icon-plus>
        Pedido de Produção Simples</b-button
      >

      <div class="lineSearch">
        <div class="summaryMonth">
          Resumo:
          <strong>{{
            selectTextDate === "Personalizado" ? "" : `(${selectTextDate})`
          }}</strong>
        </div>
        <div class="pagMonth"></div>
        <div
          style="
            padding: 0px !important;
            min-width: 40% !important;
            margin-left: 10px;
            display: flex;
            justify-content: space-between;
          "
          v-if="selectTextDate === 'Personalizado'"
        >
          <button class="btnPeriod" size="sm">Período</button>
          <div class="dateInput">
            <input
              type="date"
              id="date"
              v-model="filters.startDate"
              style="
                padding: 0.25rem 0.25rem 0.25rem 0.5rem;
                cursor: pointer;
                border-left: none;
                width: 130px;
                border-radius: 0px 5px 5px 0px;
              "
            />
            <input
              type="date"
              id="date"
              v-model="filters.endDate"
              style="
                padding: 0.25rem 0.25rem 0.25rem 0.25rem;
                cursor: pointer;
                margin-right: 20px;
              "
            />
          </div>

          <b-button
            @click="list"
            size="sm"
            class="ms-4 searchBtn"
            style="margin-left: 7px; border-left: 1px solid #c3c1c1"
          >
            <b-icon-search></b-icon-search>
          </b-button>
        </div>

        <div style="width: 25px">
          <DropdownFilters @handleFilterDays="handleFilterDays" />
        </div>
      </div>
    </div>

    <div style="width: 100%; height: 1px; padding: 0 1.3rem">
      <span
        style="
          display: flex;
          width: 100%;
          height: 1px;
          background-color: rgb(227, 227, 227);
        "
      />
    </div>

    <div class="ContainerSearchInput">
      <div class="textRegister">
        <span>P.P Simples Registradas</span>
      </div>

      <div class="searchContainer">
        <div class="searchInput">
          <b-form-select
            class="searchFilter"
            size="sm"
            value-field="value"
            text-field="text"
            v-model="filters.type"
            :options="filterCombobox"
          ></b-form-select>

          <div>
            <b-input
              placeholder="Pesquisar por..."
              v-model="filters.text"
              @keyup.enter="list"
            ></b-input>
          </div>
          <b-button size="sm" @click="list" class="searchBtn">
            <b-icon-search></b-icon-search>
          </b-button>
        </div>
      </div>
    </div>

    <div class="carrosel">
      <button class="arrowCardLeft" @click="scrollLeft">
        <b-icon-caret-left-fill
          scale="2"
          style="color: #c5c5c5"
        ></b-icon-caret-left-fill>
      </button>
      <div class="situation" ref="carrosselItens">
        <button
          v-for="situation in allSituations"
          :key="situation.text"
          :class="`situationItem ${situation.border}`"
          :name="situation.text"
          @click="handleList(situation.text)"
        >
          <div
            style="
              width: 100%;
              display: flex;
              flex-direction: column;
              gap: 0.3rem;
              padding: 0.3rem 0;
            "
          >
            <p
              :style="`
                  font-size: 12px;
                  padding: 0.1rem 0.3rem;
                  border-radius: 50px;
                  margin: 0;
                  font-family: Poppins-Regular, sans-serif !important;
                  font-weight: 600;
                `"
            >
              {{ handleShowSituationText(situation.text) }}
            </p>

            <p
              style="
                margin: 0;
                text-align: center;
                font-size: 15px;
                font-family: Poppins-Regular, sans-serif !important;
                font-weight: 600;
              "
            >
              {{ handleCountSituation(situation.text) }}
            </p>
          </div>
        </button>
      </div>
      <button class="arrowCardRight" @click="scrollRight">
        <b-icon-caret-right-fill
          scale="2"
          style="color: #c5c5c5"
        ></b-icon-caret-right-fill>
      </button>
    </div>

    <ProductionOrderTable
      :productionOrders="productionOrders"
      :nextPage="nextPage"
      :previousPage="previousPage"
      :page="filters.page"
      @openToEdit="modalHeight"
      @deletedProcutionOrder="list"
      @situationUpdated="list"
    />

    <div :class="sizeModal">
      <div :class="modalContainer" v-if="colapseModal">
        <b-button class="closeModal" @click="modalHeight"> X </b-button>

        <ProductionOrder />
      </div>
    </div>
  </div>
</template>

<script>
import { DateTime } from "luxon";
import ProductionOrder from "./ProductionOrder.vue";
import ProductionOrderTable from "./ProductionOrderTable.vue";
import ServiceProductionOrder from "../../services/serviceProductionOrder";

import DropdownFilters from "../UI/DropdownFilters/DropdownFilters.vue";

export default {
  components: {
    ProductionOrderTable,
    ProductionOrder,
    DropdownFilters,
  },
  data() {
    return {
      filters: {
        text: "",
        type: "",
        startDate: "",
        endDate: "",
        situation: "",
        page: 1,
      },
      dataFilterNfse: [],
      productionOrders: [],
      countSituations: [],
      selectTextDate: "Hoje",
      filterCombobox: [
        { value: "nomeCliente", text: "Cliente" },
        { value: "nomeFuncionario", text: "Funcionário" },
        { value: "codReferencia", text: "Referência" },
        { value: "numero", text: "Número" },
        { value: "", text: "Selecione..." },
      ],
      allSituations: [
        {
          text: "pendente",
          border: "pendingSituationItem",
          count: 0,
        },
        {
          text: "aprovado",
          border: "approvedSituationItem",
          count: 0,
        },
        {
          text: "em_separacao",
          border: "separationSituationItem",
          count: 0,
        },
        {
          text: "producao",
          border: "productionSituationItem",
          count: 0,
        },
        {
          text: "pronta_entrega",
          border: "deliverySituationItem",
          count: 0,
        },
        {
          text: "finalizado",
          border: "finishedSituationItem",
          count: 0,
        },
        {
          text: "pausado",
          border: "stopedSituationItem",
          count: 0,
        },
        {
          text: "cancelado",
          border: "canceledSituationItem",
          count: 0,
        },
      ],
      modalContainer: "contentModalDisable",
      colapseModal: false,
      sizeModal: "disable",
    };
  },
  methods: {
    clearSearch() {
      this.filters = {
        text: "",
        type: "",
        situation: "",
        startDate: DateTime.local().toSQLDate(),
        endDate: DateTime.local().toSQLDate(),
        page: 1,
      };
    },

    scrollLeft() {
      const carrosselDiv = this.$refs.carrosselItens;
      carrosselDiv.scrollLeft -= 196;
    },

    scrollRight() {
      const carrosselDiv = this.$refs.carrosselItens;
      carrosselDiv.scrollLeft += 196;
    },

    handleShowSituationText(situation = "pendente") {
      const situations = {
        pendente: "Pendentes",
        aprovado: "Aprovados",
        em_separacao: "Em Separação",
        producao: "Em Produção",
        pronta_entrega: "Pronta Entrega",
        finalizado: "Finalizados",
        cancelado: "Cancelados",
        pausado: "Pausados",
      };

      return situations[situation];
    },

    async modalHeight() {
      this.colapseModal = !this.colapseModal;

      this.colapseModal
        ? (this.sizeModal = "modalGeneral")
        : (this.sizeModal = "disable");

      this.modalContainer = this.modalContainer
        ? "modalContainer"
        : "contentModalDisable";

      if (!this.colapseModal) this.list();
    },

    async handleFilterDays(valueDate, textValueDate) {
      this.clearSearch();
      this.selectTextDate = textValueDate;

      const today = DateTime.local();

      const rangeGenerators = {
        hoje: () => ({
          start: today.toSQLDate(),
          end: today.toSQLDate(),
        }),
        ontem: () => {
          const d = today.minus({ days: 1 });
          return {
            start: d.toSQLDate(),
            end: d.toSQLDate(),
          };
        },
        esteMes: () => ({
          start: today.startOf("month").toSQLDate(),
          end: today.endOf("month").toSQLDate(),
        }),
        mesPassado: () => {
          const d = today.minus({ months: 1 });
          return {
            start: d.startOf("month").toSQLDate(),
            end: d.endOf("month").toSQLDate(),
          };
        },
        "7dias": () => ({
          start: today.minus({ days: 7 }).toSQLDate(),
          end: today.toSQLDate(),
        }),
        "30dias": () => ({
          start: today.minus({ days: 30 }).toSQLDate(),
          end: today.toSQLDate(),
        }),
        ultimos3meses: () => ({
          start: today.minus({ months: 3 }).startOf("month").toSQLDate(),
          end: today.toSQLDate(),
        }),
      };

      const generator = rangeGenerators[valueDate];

      if (generator) {
        const { start, end } = generator();
        this.filters.startDate = start;
        this.filters.endDate = end;
      }

      await this.list();
    },

    async list() {
      const result = await ServiceProductionOrder.list(
        this.filters.text,
        this.filters.type,
        this.filters.situation,
        this.filters.startDate,
        this.filters.endDate,
        this.filters.page
      );

      this.productionOrders = result.productionOrders;
      this.countSituations = result.countSituations;
    },

    async handleList(situationName) {
      this.filters.situation = situationName;

      await this.list();
    },

    nextPage() {
      this.filters.page = this.filters.page += 1;
      this.list();
    },

    previousPage() {
      if (this.filters.page === 1) {
        return;
      }

      this.filters.page = this.filters.page -= 1;
      this.list();
    },

    handleCountSituation(situationName) {
      return (
        this.countSituations?.find((count) => count.situacao === situationName)
          ?.total || 0
      );
    },
  },
  mounted() {
    this.filters.startDate = DateTime.local().toSQLDate();
    this.filters.endDate = DateTime.local().toSQLDate();

    this.list();
  },
};
</script>

<style scoped>
.General {
  display: flex;
  flex-direction: column;
  margin-left: 80px;
  width: calc(100% - 100px);
  height: 100vh;
  font-size: 12px;
  position: relative;
}

.ContainerBtn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px;
  padding: 0px 0px 5px 0px;
  margin: 70px 22px 5px 22px;
  gap: 30px;
}

.summaryMonth {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
  cursor: context-menu;
  padding: 0 0 0 7px;
}

.Btn {
  width: 30%;
  min-width: 240px;
  border: none;
  height: 35px;
  border-radius: 3px;
  font-size: 12px;
  box-shadow: 0px 12px 4px -10px rgba(142, 142, 142, 0.78);
}

.monthResume {
  white-space: nowrap;
}

.lineSearch {
  display: flex;
  align-items: center;
  width: auto;
  min-width: 360px;
  gap: 0.5rem;
}

.searchByMonth {
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 5px;
  justify-content: space-around;
  border: 1px solid #e3e0e0;
}

.pagMonth {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.custom-select3 {
  left: 4px;
  -moz-appearance: none;
  appearance: none;
  background: none;
  font-weight: bold;
  padding: 0 !important;
}

.arrows {
  border-radius: 50%;
  width: 20px;
  height: 20px;
}

.arrows:hover {
  background: whitesmoke;
}

.Summary {
  display: flex;
  gap: 0.3rem;
  height: 70px;
  width: 100%;
  padding-bottom: 5px;
  justify-content: space-evenly;
  align-items: center;
  border-bottom: 1px solid rgb(235, 235, 235);
}

.ItemSummary {
  width: 18%;
  height: 60px;
  border-radius: 5px;
  gap: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: 100;
  box-shadow: 0px 12px 4px -10px rgba(142, 142, 142, 0.78);
  cursor: pointer !important;
}

.ItemSummary span {
  cursor: context-menu;
}

.titleSummary {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.ContainerSearchInput {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
  width: 100%;
  padding: 0 10px 0 0;
  max-width: 100%;
}

.textRegister {
  font-weight: bold;
  padding-left: 20px;
}

.searchContainer {
  display: flex;
  gap: 10px;
}

.searchInput {
  display: flex;
  margin: 5px;
}

.form-control-sm {
  padding: 0.25rem 1.5rem;
  height: 30px;
}

.form-control {
  font-size: 13px;
}

.custom-select {
  left: 4px;
  position: relative;
  font-weight: 600;
  border: 1px solid rgb(195, 193, 193);
  -moz-appearance: none;
  appearance: none;
  cursor: pointer;
}

.dateInput {
  display: flex;
  gap: 10px;
  width: 250px;
}

.btnPeriod {
  border-radius: 5px 0px 0px 5px;
  border: 1px solid rgb(195, 193, 193);
  height: 30px;
  font-size: 11px;
  cursor: context-menu;
}

input {
  border: 1px solid rgb(195, 193, 193);
  border-radius: 5px;
  height: 30px;
  font-size: 11px;
}

.searchFilter {
  width: 150px;
  border-right: none;
  height: 30px;
  font-size: 11px;
  border-radius: 5px 0px 0px 5px;
  text-align: center;
  font-family: Poppins-Regular, sans-serif !important;
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

.searchFilter:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

.searchFilter2 {
  width: 150px;
  border-right: none;
  height: 30px;
  font-size: 11px;
  border-radius: 0;
  text-align: center;
  font-family: Poppins-Regular, sans-serif !important;
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

.searchFilter2:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

.searchBtn {
  right: 5px;
  height: 30px;
  position: relative;
  background: whitesmoke;
  color: black;
  border-radius: 0px 5px 5px 0px;
  border-left: none;
  border-color: #e3e0e0;
}

input {
  border: 1px solid #e3e0e0;
  border-radius: 5px;
  height: 30px;
  border: 1px solid rgb(195, 193, 193);
}

input:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

input::placeholder {
  font-size: 11px;
}

button:focus {
  box-shadow: none;
}

.closeModal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  right: 0;
  z-index: 900;
  font-size: 18px;
  height: 30px;
  background: white;
  border: none;
  color: rgb(6, 6, 6);
}

.closeModal:hover {
  background: whitesmoke;
  color: red;
}

.modalGeneral {
  position: fixed !important;
  z-index: 900;
  top: 53px;
  left: 61px;
  height: calc(100% - 53px);
  max-height: calc(100% - 53px);
  overflow: auto;
  width: calc(100% - 62px);
  background: #ffff;
  transition: all 0.7s ease-in-out;
}

.disable {
  position: fixed;
  width: calc(100% - 62px);
  height: 0;
  left: 61px;
  top: 100vh;
  background: #b0b0b000;
  visibility: hidden;
  transition: all 0.7s ease-in-out;
}

.contentModalDisable {
  display: none;
  background: white;
  opacity: 0;
}

.modalContainer {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
}

/* carrosel */
.carrosel {
  display: flex;
  padding: 0 20px;
  margin-bottom: 20px;
}

.arrowCardLeft {
  border: none;
  padding: 0 0.1rem;
  border-radius: 5px 0 0 5px;
  border: solid 1px rgb(220, 220, 220);
}

.arrowCardRight {
  border: none;
  padding: 0 0.1rem;
  border-radius: 0 5px 5px 0;
  border: solid 1px rgb(220, 220, 220);
}

.situation {
  display: flex;
  align-items: center;
  height: 74px;
  width: 100%;
  gap: 1rem;
  overflow-x: scroll;
  overflow-y: hidden;
  transition: transform 0.5s ease-in-out;
  padding: 5px 10px;
  margin: 0;
  border: solid 1px rgb(220, 220, 220);
  scroll-behavior: smooth;
}

.StatementOnAccountDefault {
  font-weight: bold;
  font-size: 14px;
  color: gray;
  width: 100%;
  height: 47px;
  display: flex;
  align-items: center;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: rgba(245, 245, 245, 0.696);
  justify-content: center;
}

.situation::-webkit-scrollbar {
  width: 2px;
  height: 2px;
}

.situation::-webkit-scrollbar-track {
  background: white;
}

.situation::-webkit-scrollbar-thumb {
  background-color: rgb(62, 102, 174);
  border-radius: 2px;
}

.situationItem {
  width: 180px;
  min-width: 180px;
  height: 60px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: rgba(245, 245, 245, 0.696);
  display: flex;
  flex-direction: column;
  align-items: center;
  white-space: nowrap;
  text-transform: capitalize;
  transition: ease-in all 0.1s;
}

.situationItem p {
  font-weight: 600;
}

.situationItem:hover {
  background: rgb(239 239 239);
  transition: ease-in all 0.1s;
}

.pendingSituationItem {
  border: ridge 3px rgb(173, 156, 32) !important;
}

.approvedSituationItem {
  border: ridge 3px rgb(0 135 245) !important;
}

.separationSituationItem {
  border: ridge 3px rgb(104 100 100) !important;
}

.productionSituationItem {
  border: ridge 3px rgb(0 176 98) !important;
}

.deliverySituationItem {
  border: ridge 3px rgb(19, 145, 135) !important;
}

.finishedSituationItem {
  border: ridge 3px rgb(4, 120, 87) !important;
}

.stopedSituationItem {
  border: ridge 3px rgb(160, 105, 4) !important;
}

.canceledSituationItem {
  border: ridge 3px rgb(165, 42, 42) !important;
}
/* carrosel */

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .General {
    margin-left: 60px;
    width: calc(100% - 60px);
    font-size: 11px;
  }

  .ContainerBtn {
    padding: 0px;
  }

  .dateInput {
    gap: 3px;
  }

  .Btn {
    width: 33%;
    height: 30px;
    font-size: 11px;
  }

  .searchByMonth {
    margin: 10px 0px 10px 8px;
  }

  .Summary {
    padding-bottom: 10px;
  }

  .ItemSummary {
    width: 18%;
    height: 50px;
    gap: 0px;
    cursor: pointer !important;
  }

  .textRegister {
    margin: 10px 10px 0px 0px;
  }

  .textRegister span {
    padding-left: 5px;
  }

  .searchInput {
    margin: 10px 10px 0px 0px;
  }

  .searchFilter,
  .searchFilter2 {
    width: 80px;
  }

  .lineSearch {
    padding: 0px;
  }
}

@media screen and (max-width: 750px) {
  .monthResume {
    display: none;
  }

  .lineSearch {
    min-width: auto;
  }
}

@media screen and (max-width: 700px) {
  .modalGeneral {
    width: 100%;
    left: 0;
    top: 0;
    height: 100%;
    max-height: 100%;
  }

  .General {
    margin-left: 0px;
    width: 100%;
    height: 100vh;
    font-size: 10px;
  }

  .ContainerBtn {
    justify-content: center;
    margin-top: 55px;
    margin-bottom: 0;
  }

  .dateInput {
    gap: 20px;
  }

  .Btn {
    width: 80%;
    height: 30px;
  }

  .ItemSummary {
    width: 19%;
    text-align: center;
    height: 70px;
    gap: 0px;
    align-items: center;
    justify-content: center;
    cursor: pointer !important;
  }

  .searchInput {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 3px;
  }

  .searchFilter,
  .searchFilter2 {
    width: 80px;
  }

  .lineSearch {
    align-items: center;
    justify-content: center;
  }

  .searchByMonth {
    margin: 5px 0px 5px 20px;
  }
}

@media screen and (max-width: 500px) {
  .ContainerBtn {
    flex-wrap: wrap;
    margin-bottom: 8px;
  }

  .carrosel {
    padding: 0 8px;
  }

  .Btn {
    position: absolute;
    top: 20px;
    left: 8px;
  }

  .lineSearch {
    width: 100%;
  }
}
</style>